var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 2.10218 0.15051 1.72064 0.418419 1.43934C0.686328 1.15804 1.04969 1 1.42857 1H18.5714C18.9503 1 19.3137 1.15804 19.5816 1.43934C19.8495 1.72064 20 2.10218 20 2.5C20 2.89782 19.8495 3.27936 19.5816 3.56066C19.3137 3.84196 18.9503 4 18.5714 4H1.42857C1.04969 4 0.686328 3.84196 0.418419 3.56066C0.15051 3.27936 0 2.89782 0 2.5ZM0 10C0 9.60218 0.15051 9.22064 0.418419 8.93934C0.686328 8.65804 1.04969 8.5 1.42857 8.5H18.5714C18.9503 8.5 19.3137 8.65804 19.5816 8.93934C19.8495 9.22064 20 9.60218 20 10C20 10.3978 19.8495 10.7794 19.5816 11.0607C19.3137 11.342 18.9503 11.5 18.5714 11.5H1.42857C1.04969 11.5 0.686328 11.342 0.418419 11.0607C0.15051 10.7794 0 10.3978 0 10ZM8.57143 17.5C8.57143 17.1022 8.72194 16.7206 8.98985 16.4393C9.25776 16.158 9.62112 16 10 16H18.5714C18.9503 16 19.3137 16.158 19.5816 16.4393C19.8495 16.7206 20 17.1022 20 17.5C20 17.8978 19.8495 18.2794 19.5816 18.5607C19.3137 18.842 18.9503 19 18.5714 19H10C9.62112 19 9.25776 18.842 8.98985 18.5607C8.72194 18.2794 8.57143 17.8978 8.57143 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.cbf738ebe599d1b95cbaaeecfd5d6178.svg";
export { ForwardRef as ReactComponent };